import type { ShopperProducts } from '@/scapi';
import type { ContentFolder } from '@/lib/api/content-folders.server';
import type { CategoryProductCounts } from '@/lib/category-product-counts';

type Category = ShopperProducts.schemas['Category'];

const EMPTY_CONTENT_FOLDERS = Promise.resolve([] as ContentFolder[]);
const EMPTY_CATALOG_TREE = Promise.resolve({ id: 'root', categories: [] } as Category);
const EMPTY_CATEGORY_PRODUCT_COUNTS = Promise.resolve(undefined as CategoryProductCounts | undefined);

export type CatalogMenuData = [Category, ContentFolder[], CategoryProductCounts | undefined];

export function createCatalogMenuDataPromise(
    catalogTree?: Promise<Category>,
    contentFolders?: Promise<ContentFolder[]>,
    categoryProductCounts?: Promise<CategoryProductCounts | undefined>
): Promise<CatalogMenuData> {
    return Promise.all([
        catalogTree ?? EMPTY_CATALOG_TREE,
        contentFolders ?? EMPTY_CONTENT_FOLDERS,
        categoryProductCounts ?? EMPTY_CATEGORY_PRODUCT_COUNTS,
    ]);
}
